module.exports = __webpack_public_path__ + "static/media/profile.8d0b9b03.png";